<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">{{ new Date().getFullYear() - 1 }} - {{ new Date().getFullYear() }} © {{empresa}}</div>
        <div class="col-sm-6">
          <div class="text-sm-end d-none d-sm-block">Design & Develop by Silvio Coelho</div>
        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>

<script>
export default {
  computed:{
    empresa(){
      //let objEmpresa = JSON.stringify({id:1, nome: 'Itiban'})
      //localStorage.setItem("empresa", objEmpresa)
      
      let empresaSelecionada = {}
      empresaSelecionada.nome = 'Infinity Group S.A.'
      
      if((localStorage.getItem("empresa") !== 'undefined') && (localStorage.getItem("empresa") !== null)){
        empresaSelecionada = JSON.parse(localStorage.getItem("empresa"))
      }
      
      return empresaSelecionada.nome
    }
  }
}
</script>
